import { render } from "./SelectionInput.vue?vue&type=template&id=033e20fa"
import script from "./SelectionInput.vue?vue&type=script&lang=js"
export * from "./SelectionInput.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__